/**
 * Added to uncoupled sliding doors that should be marked red by the PlatsaUncoupledSlidingDoorSystem
 */
class PlatsaUncoupledSlidingDoorComponent {
    constructor() {
        this.typeId = PlatsaUncoupledSlidingDoorComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
PlatsaUncoupledSlidingDoorComponent.id = 2052;
export default PlatsaUncoupledSlidingDoorComponent;
//# sourceMappingURL=PlatsaUncoupledSlidingDoorComponent.js.map